import { render, staticRenderFns } from "./TeacherSlider.vue?vue&type=template&id=31df3726&scoped=true&"
import script from "./TeacherSlider.vue?vue&type=script&lang=js&"
export * from "./TeacherSlider.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSlider.vue?vue&type=style&index=0&id=31df3726&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df3726",
  null
  
)

export default component.exports